import React, { useState, useEffect } from 'react'
import { message, Pagination } from 'antd'
import Loader from '../Loader/Loader'
import { getRelationCategory, deleteRelationCategory } from '../../Web Apis/Apis'
import Avtar from '../../Images/no image.png'
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";
import CreateRelation from './CreateRelation'
import UpdateRelation from './UpdateRelation'


function Relationcategory() {
  const [loading, setLoading] = useState(false)
  const [relationCategory, setRelationcategory] = useState([])

  const [showCreateModalOpen, setShowCreateModalOpen] = useState(false)
  const [showUpdateModalOpen, setShowUpdateModalOpen] = useState(false)
  const [showDeleteModalOpen, setShowDeleteModalOpen] = useState(false)
  const [action, setAction] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState({})

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Calculate the current items for the page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentCategories = relationCategory.slice(indexOfFirstItem, indexOfLastItem);


  const fetchCategory = async () => {
    try {
      setLoading(true)
      const response = await getRelationCategory()
      console.log("dayta", response)
      if (response?.data?.success) {
        const reverseData = [...response?.data?.data?.subcategory].reverse()
        setRelationcategory(reverseData)
      }

    } catch (error) {
      console.log("Error while fetch relation category", error.message)
      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert("Your account is logged in to another device, please login again !")
        localStorage.clear();
        window.location.href = "/login"
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding")
      }
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    fetchCategory();
  }, [action])



  const handleUpdateModalOpen = (category) => {
    setSelectedCategory(category)
    setShowUpdateModalOpen(true)
  }

  const handleDeleteModalOpen = (category) => {
    setSelectedCategory(category)
    setShowDeleteModalOpen(true)
  }

  const handleCreateModalOpen = () => {
    setShowCreateModalOpen(true)
  }

  const hanldeDelete = async () => {
    try {
      setLoading(true)
  
      const response = await deleteRelationCategory(selectedCategory)
      if (response?.data?.success){
        message.success(response?.data?.message)
        setShowDeleteModalOpen(false)
        setAction(!action)
      }
    } catch (error) {
      console.log("Error while deleting category", error.message)
      message.error(error?.response?.data?.message || "Error occured")
    } finally {
      setLoading(false)
    }
  }



  return (
    <div className='p-4'>
      <div className='flex justify-between'>
        <h3 className='text-3xl font-bold'>Relation Category Management</h3>
        <div className='flex justify-end'>
          <button
            onClick={handleCreateModalOpen}
            className="bg-gradient-to-br from-blue-500 to-gray-500 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded"
          >
            Create
          </button>
        </div>
      </div>

      <table className='min-w-full mt-7 bg-gradient-to-br from-purple-700 to-gray-300 border border-b-4 border-black'>
        <thead>
          <tr>
            <th className="py-2 px-4 border-b text-center">S.No</th>
            <th className="py-2 px-4 border-b text-center">Relation Name</th>
            <th className="py-2 px-4 border-b text-center">Relation Image</th>
            <th className="py-2 px-4 border-b text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentCategories?.length > 0 ? (
            currentCategories?.map((category, index) => (
              <tr key={category.id}
                className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
              >
                <td className='py-2 px-4 border-b'>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td className="py-2 px-4 border-b">{category.subcategory}</td>
                <td className="py-2 px-4 border-b flex justify-center">
                  <img
                    src={category?.image || Avtar}
                    alt="category"
                    className="object-cover border border-gray-700"
                    style={{ height: "70px", width: "70px", borderRadius: "8px" }}
                  />
                </td>

                <td className="py-2 px-4 border-b">
                  <div className="flex flex-row justify-center">
                    {/* <button
                      onClick={() => handleViewModalOpen(category)}
                      className="text-blue-500 hover:text-blue-700 flex items-center"
                    >
                      <AiOutlineEye className="mr-1 text-2xl" />
                    </button> */}
                    <button
                      onClick={() => handleUpdateModalOpen(category)}
                      className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                    >
                      <AiFillEdit className="mr-1 text-2xl" />
                    </button>
                    <button
                      onClick={() => handleDeleteModalOpen(category)}
                      className="text-red-500 hover:text-red-700 flex items-center"
                    >
                      <AiFillDelete className="mr-1 text-2xl" />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className=' px-4 py-4 border-b text-center font-bold'>No relation category data found</td>
            </tr>
          )

          }
        </tbody>

      </table>

      {loading && <Loader />}


      <div className="mt-4 flex justify-end">
        <Pagination
          current={currentPage}
          total={relationCategory.length}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>


      {showCreateModalOpen && (
        <CreateRelation
          showCreateModalOpen={showCreateModalOpen}
          setShowCreateModalOpen={setShowCreateModalOpen}
          setAction={setAction}
          action={action}
        />
      )
      }

      {showUpdateModalOpen && (
        <UpdateRelation
          showUpdateModalOpen={showUpdateModalOpen}
          setShowUpdateModalOpen={setShowUpdateModalOpen}
          setAction={setAction}
          action={action}
          selectedCategory={selectedCategory}
        />
      )}


      {showDeleteModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gradient-to-br from-purple-900 to-purple-500 p-8 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-3xl font-bold mb-4 text-start text-white">Confirm Delete</h3>
            <p className="mb-4 text-start text-white">Are you sure you want to delete this category ? </p>
            <div className="flex justify-end gap-4">
              <button onClick={() => { setShowDeleteModalOpen(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                Cancel
              </button>
              <button onClick={hanldeDelete} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
                Delete
              </button>
            </div>
          </div>
        </div>
      )
      }
    </div>



  )
}

export default Relationcategory